import PropTypes from 'prop-types';
import { Dollar } from 'flowbite-react-icons/outline';
import { useCallback, useMemo } from 'preact/hooks';

export default function NumberInput({
  maxLength = 7,
  onChange,
  placeholder = '5.00',
  name,
  value,
  labelText,
  isCurrency = true,
  minValue,
  maxValue,
  disabled,
  className,
  inputClassName,
  description,
  suffix,
  testID,
}) {
  const prefix = useMemo(() => {
    if (isCurrency) return <Dollar />;
    return undefined;
  }, [isCurrency]);

  const handleChange = useCallback(
    (event) => {
      event.target.value = Math.abs(event.target.value);
      event.target.valueAsNumber = Math.abs(event.target.valueAsNumber);
      onChange && onChange(event);
    },
    [onChange]
  );

  const handleBlur = useCallback(() => {
    if (value < minValue) {
      onChange({ target: { value: minValue, valueAsNumber: minValue, name } });
    } else if (value > maxValue) {
      onChange({ target: { value: maxValue, valueAsNumber: maxValue, name } });
    }
  }, [value, minValue, name, onChange]);

  return (
    <label className={`form-control mb-2 ${className} pl-1`}>
      <div className="label">
        <span className="label-text">{labelText}</span>
      </div>
      <div className={`flex items-center gap-2 ${inputClassName}`}>
        <label className="input input-bordered flex w-full items-center gap-2">
          {prefix}
          <input
            data-testid={testID}
            disabled={disabled}
            min={minValue}
            max={maxValue}
            type="number"
            name={name}
            maxLength={maxLength}
            value={value}
            onChange={handleChange}
            onBlur={handleBlur}
            placeholder={placeholder}
            className="grow"
          />
        </label>
        {suffix}
      </div>
      {description && (
        <div className="label">
          <span className="label-text-alt">{description}</span>
        </div>
      )}
    </label>
  );
}

NumberInput.propTypes = {
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  testID: PropTypes.string,
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  suffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  name: PropTypes.string,
  value: PropTypes.number,
  labelText: PropTypes.string,
  isCurrency: PropTypes.bool,
  minValue: PropTypes.any,
  maxValue: PropTypes.any,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};
